import { useState } from "react";
import { useParams } from "react-router-dom";

//Bootstrap
import { Card } from "react-bootstrap";

//Icons
import { MdEdit } from "react-icons/md";

//UI components
import Field from "../../../ui/Field";

//API
import { useGetPartnerUM } from "../../../../services/ProjectDetails/partnerskeOrganizacijeAPI";

//components
import PartnerUMEditForm from "./PartnerUMEditForm";

//Auth
import RoleGuard from "../../../../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../../../../auth/roles";

//Context
import { useProjectDetailsContext } from "../../../../context/ProjectDetailsContext";

const PartnerUM = () => {
  const { id } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const { project } = useProjectDetailsContext();

  const { data: partnerUM, isLoading } = useGetPartnerUM(id);

  const onEditClick = () => {
    setIsEditing(true);
  };

  if (isLoading) {
    return (
      <div className="mb-3 mt-3">
        <h6 className="form-section-heading">Vloga UM v projektu</h6>
        <p>Nalaganje...</p>
      </div>
    );
  }

  return (
    <>
      <h6 className="form-section-heading">Vloga UM v projektu</h6>
      <Card className="mb-3 mt-3">
        <div className="d-flex align-items-center justify-content-between px-3 pt-3">
          <h5 className="mb-0">{partnerUM?.nazivSlo}</h5>
          {!isEditing && (
            <RoleGuard
              moduleKey={MODULES.PROJEKTI}
              roles={ROLE_GROUPS.EDITORS_AND_SKRBNIK}
              vodilnaClanicaProjektaID={project?.clanicaID}
            >
              <button
                className="btn btn-sm btn-outline-primary uredi-btn-tab-card-header border-0"
                onClick={onEditClick}
                disabled={isEditing}
              >
                <span className="d-flex align-items-center gap-1">
                  Uredi <MdEdit />
                </span>
              </button>
            </RoleGuard>
          )}
        </div>
        {!isEditing && (
          <div className="px-3 pb-3">
            <Field
              label=""
              value={partnerUM?.vloga}
              className="mb-2 text-primary fw-bold"
              showLabel={false}
            />
            <Field
              label="Vodja projekta"
              value={partnerUM?.vodjaProjektaNaUM || partnerUM?.vodjaProjekta}
              className="mb-2"
            />
            <Field
              label="Vodilna članica"
              value={partnerUM?.skrbnik}
              className="mb-0"
            />
          </div>
        )}
        {isEditing && (
          <PartnerUMEditForm
            partnerUM={partnerUM}
            setIsEditing={setIsEditing}
          />
        )}
      </Card>
    </>
  );
};

export default PartnerUM;
